import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="test-api"
export default class extends Controller {

  static values = {
    testPath: String
  };

  static targets = [
    "urlInput",
    "apiTokenInput",
    "feedbackOutput",
  ]

  declare testPathValue: string
  declare urlInputTarget: HTMLInputElement
  declare apiTokenInputTarget: HTMLInputElement
  declare feedbackOutputTarget: HTMLOutputElement

  connect() {
  }

  async testConnection() {
    this.feedbackOutputTarget.classList.remove("text-danger-subtle");
    this.feedbackOutputTarget.classList.remove("text-success-subtle");
    this.feedbackOutputTarget.textContent = "";
    try {
      const testUrl = new URL(this.testPathValue, this.urlInputTarget.value)
      const res = await fetch(testUrl, {
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${this.apiTokenInputTarget.value.trim()}`,
        }
      });

      if (res.ok) {
        this.renderFeedbackSuccess();
      } else {
        this.renderFeedbackError("Response was not OK, details:\n"+JSON.stringify({ status: res.statusText, body: await res.json() }, null, 2));
      }
    } catch (e) {
      this.renderFeedbackError(e.message);
    }
  }

  renderFeedbackSuccess() {
    this.feedbackOutputTarget.classList.add("text-success-subtle");
    this.feedbackOutputTarget.textContent = "It worked!";
  }

  renderFeedbackError(error: string) {
    this.feedbackOutputTarget.classList.add("text-danger-subtle");
    this.feedbackOutputTarget.textContent = error;
  }
}
